// Runs a response through local scoring, then augments with the LLM judgment
// (on-target gate + point-first / tangent scoring + a feedback line) when the
// /api/evaluate function is configured. Always resolves — never blocks the rep.

import { scoreLocal, mergeWithLLM, localFeedback } from "./scoring";

export async function evaluateResponse({ text, prompt, shape }) {
  const local = scoreLocal(text);

  let llm = null;
  try {
    const res = await fetch("/api/evaluate", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        response: text,
        prompt,
        shape: { id: shape.id, label: shape.label, hint: shape.hint },
        wordCount: local.words,
        sentenceCount: local.sentences,
      }),
    });
    if (res.ok) llm = await res.json();
  } catch (e) {
    llm = null;
  }

  const merged = mergeWithLLM(local, llm);
  if (!merged.feedback) merged.feedback = localFeedback(merged);
  return merged;
}
